import * as bootstrap from 'bootstrap';
import { Spinner } from '../components/spinner';
import 'js-cookie';
import Cookies from 'js-cookie';

const isOrderReceivedPage = document.querySelector('body.woocommerce-order-received') || false;
const surveyModal = document.querySelector('#survey-modal') ? new bootstrap.Modal('#survey-modal') : false;
const surveyUI = document.querySelector('#loveli-thankyou-survey') || false;
const submitBtn = document.querySelector('#submit_survey') || false;
const spinner = new Spinner();
spinner.classList.add('ms-2');
const cookie = 'loveli_ty_survey_answered';

(() => {
    if (Cookies.get(cookie)) return;
    if (!isOrderReceivedPage || !surveyUI || !submitBtn || !surveyModal) return;

    let orderId = submitBtn.dataset.orderId;
    let choice;
    const otherRadio = document.querySelector('input#other');
    const otherInput = document.querySelector('input#other_value');
    let otherValue;
    let answerId;

    setTimeout(() => {
        surveyModal.show();
    }, 1000);

    surveyUI.addEventListener('change', () => {
        submitBtn.disabled = false;
        if (otherRadio.checked) {
            otherInput.classList.remove('d-none');
        } else {
            otherInput.classList.add('d-none');
        }
    });

    submitBtn.addEventListener('click', () => {
        choice = document.querySelector('input[name="survey_choice"]:checked');
        answerId = choice.id;

        otherValue = answerId === 'other' ? document.querySelector('input#other_value').value : answerId;

        saveChoiceToDatabase(orderId, answerId, otherValue);
    });
})();

/**
 * Saves the users survey choice to the database
 *
 * @param {int} orderId
 * @param {int} answerId
 * @param {mixed} otherValue
 */
async function saveChoiceToDatabase(orderId, answerId, otherValue) {
    blockUI();

    let formData = new FormData();
    formData.append('action', 'process_survey');
    formData.append('order_id', orderId);
    formData.append('answer_id', answerId);
    formData.append('answer_value', otherValue ?? answerId);

    fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData,
    })
        .then((res) => res.text())
        .then((data) => {
            unBlockUI();
            Cookies.set(cookie, true, { expires: 365 });
        })
        .catch((err) => {
            // console.log(err);
            unBlockUI(false);
        });
}

/**
 * Blocks the UI and adds a spinner
 */
function blockUI() {
    surveyUI.querySelectorAll('input').forEach((input) => {
        input.disabled = true;
    });

    submitBtn.disabled = true;

    submitBtn.append(spinner);
}

/**
 * Closes off the modal and removes the element from the dom
 *
 * @param {boolean} success
 */
async function unBlockUI(success = true) {
    surveyModal._element.addEventListener('hidden.bs.modal', () => {
        surveyModal._element.remove();
    });

    if (success) {
        Spinner.animationSuccess(spinner, () => {
            surveyModal.hide();
        });
    } else {
        // For now, do nothing. Just hide the modal.
        spinner.remove();
        surveyModal.hide();
    }
}
